import React, { useEffect, useState } from "react";
import { AzulesContainer } from "./styles";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName } from "../../Trajes/Negros/styles";

const Tazules = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [showButton, setShowButton] = useState(false);
    
    const enviarWhatsApp = (modelo) => {
        const numero = "5213311407070";
        const mensaje= `Hola, me gustaría cotizar el servicio de *${modelo}*`;
        const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

        window.open(url, "_blank");
    }

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    };

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    return(
        <>
            <AzulesContainer>
                <p>Togas azules</p>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>
                <NavMenu collapsed={collapsed}>
                    <NavItem
                        active = {location.pathname === "/"}
                        onClick={() => navigate("/")}
                    >
                        Inicio
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/trajes"}
                        onClick={() => navigate("/trajes")}
                    >
                        Trajes
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/smokings"}
                        onClick={() => navigate("/smokings")}
                    >
                        Smokings
                    </NavItem>

                    <NavItem
                        active = {location.pathname.startsWith("/togas")}
                        onClick={() => navigate("/togas")}
                    >
                        Togas
                    </NavItem>
                    <NavItem>
                        <a 
                            href="/catalogo-togas" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </AzulesContainer>
            <ModelGrid>
                <ModelCard onClick={() => enviarWhatsApp("Toga Azul De Adulto")}>
                    <ModelImage src="/img/Toga-azul.jpg" alt="Toga azul"/>
                    <ModelInfo>
                        <ModelName>Toga Azul De Adulto</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard onClick={() => enviarWhatsApp("Toga Azul De Niño")}>
                    <ModelImage src="/img/Toga-azul-nino.jpg" alt="Toga azul para nino"/>
                    <ModelInfo>
                        <ModelName>Toga Azul De Niño</ModelName>
                    </ModelInfo>
                </ModelCard>
            </ModelGrid>

            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Tazules;